<template>
  <div class="photovoltaicBenefits" v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="row1">
      <div class="row1Left ashComWrap">
        <div class="comTitle">
          <h4>用电分析</h4>
        </div>
        <div class="comContentBox powerContent">
          <div class="ringBox">
            <PublicEcharts
              :id="'box2'"
              :chartsData="orderData"
              :type="'ringChart'"
            />
          </div>
          <div class="stacking">
            <PublicEcharts
              :id="'stackedColumn'"
              :chartsData="chartsData"
              :type="'stackedColumnBar'"
            />
          </div>
        </div>
      </div>
      <div class="row1Right ashComWrap">
        <div class="comTitle">
          <h4>节能降碳</h4>
        </div>
        <div class="comContentBox">
          <ul>
            <li v-for="(v, i) in savingList" :key="i">
              <h5>{{ v.value }}</h5>
              <el-tooltip
                :disabled="v.key !== 'EquivalentTree'"
                effect="dark"
                content="一颗树平均寿命40年,平均每年吸收18.3kg二氧化碳"
                placement="bottom"
              >
                <p>{{ v.name }}</p>
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <AnalysisTable
      :title="'用电详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="
        judgeAuthority('zixitong:guangfu:photovoltaicBenefits:export')
      "
    />
  </div>
</template>

<script>
import api from "@/api";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import PublicEcharts from "@/components/PublicEcharts";
import { dateFtt, judgeAuthority, handleNumDecimal } from "@/assets/js/utils";
export default {
  components: {
    AnalysisHead,
    AnalysisTable,
    PublicEcharts,
  },
  data() {
    return {
      excelTitle: "",
      tabHead: [],
      tableData: [],
      savingList: [],
      orderData: { unit: "", dataArr: [] },
      chartsData: {
        unit: "kw·h",
        xData: [],
        dataArr: [],
      },
      proportion: {
        title: "节约率",
        value: 0,
      },
    };
  },
  methods: {
    judgeAuthority,
    getTableHeade(data) {
      this.tabHead = [
        { label: "时间", prop: "time" },
        {
          label: `总用电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "ProjectUse",
        },
        {
          label: `峰电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "Peek_EC_Hour",
        },
        {
          label: `谷电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "Valley_EC_Hour",
        },
        {
          label: `平电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "Flat_EC_Hour",
        },
        {
          label: `尖电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "Tip_EC_Hour",
        },
        {
          label: `光伏发电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "EC_Hour",
        },
        {
          label: `光伏用电/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "PvUse",
        },
        {
          label: `光伏并网/${data.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "Up_EC_Hour",
        },
      ];
    },
    getActiveTime(val) {
      this.$store.commit("SET_LOADING", true);
      this.excelTitle = `光伏效益-${val.timeValue ? val.timeValue : "全部"}`;
      let data = Object.assign({}, val, { startTime: "", endTime: "" });
      this.getTableHeade(data);
      if (data.type == "UNLIMITED") {
        data.startTime = new Date("2021-01-01 00:00:00").getTime();
        data.endTime = new Date().getTime();
      } else {
        data.startTime = this.$moment(new Date(val.timeValue))
          .startOf(
            data.type == "MONTH" ? "months" : data.type == "YEAR" ? "year" : ""
          )
          .format("x");
        data.endTime = this.$moment(new Date(val.timeValue))
          .endOf(
            data.type == "MONTH" ? "months" : data.type == "YEAR" ? "year" : ""
          )
          .format("x");
      }
      this.getTable(data);
      this.getEnergySaveInfo(data);
      this.getECFun(data);
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    async getTable(data) {
      this.tableData = [];
      let res = await api.PVOSBenefitsTable({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: data.startTime,
        endTime: data.endTime,
        period: data.key,
      });
      if (res && res.data.code == 200) {
        let obj = res.data.data.tsValue;
        for (let key in obj) {
          for (let item in obj[key]) {
            obj[key][item] = handleNumDecimal(
              data.type == "MONTH" ? obj[key][item] : obj[key][item] / 10000
            );
          }
          let row = Object.assign(obj[key], {
            time:
              data.type == "MONTH"
                ? dateFtt("dd日", new Date(Number(key)))
                : data.type == "YEAR"
                ? dateFtt("MM月", new Date(Number(key)))
                : dateFtt("yyyy年", new Date(Number(key))),
            ts: Number(key),
          });
          this.tableData.push(row);
          this.tableData.sort(function (a, b) {
            return a.ts - b.ts;
          });
        }
      }
    },
    async getEnergySaveInfo(data) {
      this.savingList = [
        { name: "减少CO₂排放/吨", value: null, key: "CO2Rate" },
        // { name: "减少碳排放/吨", value: null, key: "CarbonRate" },
        { name: "节约标准煤/吨", value: null, key: "KGCERage" },
        { name: "减少SO₂排放/吨", value: null, key: "SO2Rate" },
        { name: "等效植树/棵", value: null, key: "EquivalentTree" },
        // { name: "碳权/吨", value: null, key: "CarbonRight" },
      ];
      let res = await api.PVOSEnergySaveInfo({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: data.startTime,
        endTime: data.endTime,
        period: data.key,
      });
      if (res && res.data.code == 200) {
        this.savingList.map((v) => {
          v.value = handleNumDecimal(res.data.data[v.key]);
        });
      }
    },
    async getECFun(data) {
      this.orderData.unit = "";
      this.orderData.dataArr = [
        { value: null, name: "光伏", key: "Sum_EC_Hour", unit: "kw·h" },
        { value: null, name: "谷电", key: "Sum_Valley_EC_Hour" },
        { value: null, name: "峰电", key: "Sum_Peek_EC_Hour" },
        { value: null, name: "平电", key: "Sum_Flat_EC_Hour" },
        { value: null, name: "尖电", key: "Sum_Tip_EC_Hour" },
      ];
      this.chartsData.xData = [];
      this.chartsData.dataArr = [
        {
          name: "光伏",
          key: "EC_Hour",
          data: [],
        },
        {
          name: "谷电",
          key: "Valley_EC_Hour",
          data: [],
        },
        {
          name: "峰电",
          key: "Peek_EC_Hour",
          data: [],
        },
        {
          name: "平电",
          key: "Flat_EC_Hour",
          data: [],
        },
        {
          name: "尖电",
          key: "Tip_EC_Hour",
          data: [],
        },
      ];
      let res = await api.PVOSPowerTrend({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: data.startTime,
        endTime: data.endTime,
        period: data.key,
        needPeriodEc: true,
      });
      if (res && res.data.code == 200) {
        this.orderData.dataArr.map((v) => {
          v.value = res.data.data[v.key]
            ? handleNumDecimal(res.data.data[v.key])
            : 0;
        });
        this.orderData.unit = this.orderData.dataArr[0].unit ?? "";
        this.orderData.dataArr = this.orderData.dataArr.filter((v) => {
          return v.value;
        });
        let arr = [];
        let obj = res.data.data.tsValue;
        for (let key in obj) {
          let row = Object.assign(obj[key], {
            time:
              data.type == "MONTH"
                ? dateFtt("dd日", new Date(Number(key)))
                : data.type == "YEAR"
                ? dateFtt("MM月", new Date(Number(key)))
                : dateFtt("yyyy年", new Date(Number(key))),
            ts: Number(key),
          });
          arr.push(row);
        }
        arr.sort(function (a, b) {
          return a.ts - b.ts;
        });
        arr.map((v) => {
          this.chartsData.xData.push(v.time);
          this.chartsData.dataArr.map((item) => {
            item.data.push(v[item.key] ? handleNumDecimal(v[item.key]) : null);
          });
        });
        this.chartsData.dataArr = this.chartsData.dataArr.filter(
          (v) => !v.data.every((item) => item === null)
        );
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.photovoltaicBenefits {
  width: 100%;
  overflow: auto;
  .row1 {
    width: $innerWidth;
    // height: 450px;
    height: 400px;
    margin: 12px auto;
    @include setFlexBetween;
    .row1Left {
      width: 70%;
      .powerContent {
        @include setFlexBetween;
        .ringBox {
          width: 30%;
          height: 75%;
        }
        .stacking {
          width: 70%;
          height: 100%;
        }
      }
    }
    .row1Right {
      width: calc(30% - 12px);
      ul {
        width: 90%;
        height: 98%;
        margin: 1% auto;
        @include setFlexBetween;
        flex-wrap: wrap;
        li {
          width: 49%;
          // height: 31%;
          height: 45%;
          background: #f8fafb;
          border-radius: 8px;
          @include setFlexColumn;
          justify-content: center;
          align-items: center;
          h5 {
            font-size: 26px;
          }
          p {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
